// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fe508662","513":"ad1cad91","703":"1cccf3d7","787":"32514545"}[chunkId] + ".chunk.js";
};